import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { compose, lifecycle, renderNothing, branch } from 'recompose';
import queryString from 'query-string';
import { connect } from 'react-redux';

import HorizontalCenterLayout from '../../layouts/HorizontalCenterLayout';
import PageLayout from '../../layouts/PageLayout/index';
import { routerProps } from '../../propTypes';

import SubmissionItemNavEnhanced from './containers/SubmissionItemNavEnhanced';
import SubmissionItemViewer from '../submissionItemViewer/containers/SubmissionItemViewer';

import { setUserId, setCurrentSubmissionId, setWeekOfDate } from './actions';
import { getCurrentSubmissionId } from './selectors';

const propTypes = exact({
  ...routerProps,
  submissionItemId: PropTypes.number.isRequired,
  setUserIdAction: PropTypes.func.isRequired,
  setCurrentSubmissionIdAction: PropTypes.func.isRequired,
  setWeekOfDateAction: PropTypes.func.isRequired,
});

const TimesheetViewerPage = (props) => {
  const { submissionItemId } = props;

  return (
    <PageLayout
      title="Timesheet Viewer"
      render={() => {
        return (
          <HorizontalCenterLayout render={() => {
            return (
              <div>
                <SubmissionItemNavEnhanced />
                <SubmissionItemViewer
                  submissionItemId={submissionItemId}
                />
              </div>
            );
          }}
          />
        );
      }}
    />
  );
};

TimesheetViewerPage.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    submissionItemId: getCurrentSubmissionId(state),
  };
};

const mapDispatchToProps = {
  setUserIdAction: setUserId,
  setCurrentSubmissionIdAction: setCurrentSubmissionId,
  setWeekOfDateAction: setWeekOfDate,
};


const withInitPage = lifecycle({
  componentWillMount() {
    const { match: { params: { id } } } = this.props;
    const {
      location,
      setUserIdAction,
      setCurrentSubmissionIdAction,
      setWeekOfDateAction,
    } = this.props;


    const submissionItemId = parseInt(id, 10);
    setCurrentSubmissionIdAction(submissionItemId);

    const querySringObject = queryString.parse(location.search);

    const { userId, date } = querySringObject;

    const userIdValue = parseInt(userId, 10);
    if (userId && !Number.isNaN(userIdValue)) {
      setUserIdAction(userIdValue);
    }

    if (date) {
      setWeekOfDateAction(date);
    }
  },
});

/* NOTE: doesn't make query with submissionItemId if 0
* inside of SubmissionItemViewer */
const withNoSubmissionItemId = branch(
  (props) => {
    return props.submissionItemId === 0;
  },
  renderNothing,
);


const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withInitPage,
  withNoSubmissionItemId,
);

export default enhance(TimesheetViewerPage);
